import { v4 as uuidv4 } from "uuid";

export const socialsDB = [
  {
    id: uuidv4(),
    path: "https://www.facebook.com/",
    name: "facebook",
    icon: "facebook",
  },
  { id: uuidv4(), path: "https://github.com/", name: "github", icon: "github" },
  {
    id: uuidv4(),
    path: "https://www.instagram.com/",
    name: "instagram",
    icon: "insta",
  },
];
